import { date as asteroidDate } from 'asteroid'

export default [
  {
    name: 'ActivitiesList',
    path: '/activities',
    meta: { useOverlay: true },
    component: () => import('pages/activities/list/ActivitiesList.vue'),
    beforeEnter: (to, _from, next) => {
      const { date, status } = to.query

      // Se não tem query date nem status, força a data atual como padrão
      if (!date && !status) {
        const currentDate = asteroidDate(new Date(), 'yyyy-MM-dd')

        return next({ ...to, query: { ...to.query, date: currentDate }, replace: true })
      }

      next()
    }
  },
  {
    name: 'ActivitiesCreate',
    path: '/activities/new',
    meta: { useOverlay: true },
    component: () => import('pages/activities/ActivitiesCreate.vue')
  },
  {
    name: 'ActivitiesEdit',
    meta: { useOverlay: true },
    path: '/activities/:id/edit',
    component: () => import('pages/activities/edit/ActivitiesEdit.vue')
  }
]
